<template>
  <div>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/staff/staffRole')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>

    <!-- 操作面板 -->
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="设备类型" prop="serverId">
        <el-select
          v-model="form.serverId"
          placeholder="请选择设备类型"
          :disabled="true"
          @change="
            $forceUpdate();
            changeServer();
          "
        >
          <el-option
            v-for="(v, i) in fuwuduan"
            :key="i"
            :label="v.name"
            :value="v.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色名称" prop="name">
        <el-input
          :disabled="isDetail == 1"
          v-model="form.name"
          placeholder="请输入角色名称"
        ></el-input>
      </el-form-item>

      <!-- <el-form-item label="启用状态" prop="status">
        <el-select
          :disabled="$route.query.isDetail"
          v-model="form.status"
          placeholder="请选择启用状态"
        >
          <el-option label="启用" value="1"></el-option>
          <el-option label="禁用" value="0"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="功能权限">
        <div class="pd-10 bg-white quan">
          <el-checkbox-group
            :disabled="isDetail === 1"
            v-model="form.funQuan"
            @change="funQuanChange"
          >
            <el-checkbox
              v-for="(v, i) in menuType"
              :key="i"
              :label="v.dictName"
              :name="v.dictName"
            ></el-checkbox>
          </el-checkbox-group>
          <!-- 工作台数据 -->
          <div class="dataBox" v-if="form.funQuan.indexOf('首页') !== -1">
            <div v-for="(v, i) in homeArr" :key="i">
              <div class="flex aic">
                <div class="mgr-10">{{ v.name }}</div>
                <el-checkbox
                  :disabled="isDetail == 1"
                  v-model="v.checkboxAll"
                  label="1"
                  @change="homeCheckAll($event, v)"
                  >{{ "全部" }}</el-checkbox
                >
              </div>
              <el-checkbox-group
                :disabled="isDetail === 1"
                v-model="form.jobLook"
                @change="homeChange($event, v)"
              >
                <el-checkbox
                  v-for="(v2, i2) in v.children"
                  :key="i2"
                  :label="v2.id"
                  >{{ v2.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          <!-- 数据看板 -->
          <div class="dataBox" v-if="form.funQuan.indexOf('数据') !== -1">
            <div v-for="(v, i) in dataArr" :key="i">
              <div class="flex aic">
                <div class="mgr-10">{{ v.name }}</div>
                <el-checkbox
                  :disabled="isDetail == 1"
                  v-model="v.checkboxAll"
                  label="1"
                  @change="dataCheckAll($event, v)"
                  >{{ "全部" }}</el-checkbox
                >
              </div>
              <el-checkbox-group
                :disabled="isDetail === 1"
                v-model="form.dataLook"
                @change="dataChange($event, v)"
              >
                <el-checkbox
                  v-for="(v2, i2) in v.children"
                  :key="v2.id"
                  :label="v2.id"
                >
                  {{ v2.name }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="数据权限" prop="dataQuan">
        <div class="pd-10 bg-white quan">
          <el-radio-group :disabled="isDetail === 1" v-model="form.dataQuan">
            <el-radio label="2">{{ "全部数据" }}</el-radio>
            <!-- <el-radio label="1">{{ "区域数据" }}</el-radio> -->
            <el-radio label="0">{{ "个人数据" }}</el-radio>
          </el-radio-group>
          <div>数据说明:</div>
          <div>
            1、全部数据为归属企业全部设备、员工、水卡、用户等产生的数据；
          </div>
          <!-- <div>2、区域数据为管理区域下全部设备、员工、水卡等产生的数据；</div> -->
          <div>2、个人数据为管理设备、水卡等产生的数据。</div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          v-if="isDetail !== 1"
          @click="saveData('form')"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
        status: [
          { required: true, message: "请选择启用状态", trigger: "blur" },
        ],
        dataQuan: [
          { required: true, message: "请选择数据权限", trigger: "blur" },
        ],
      },
      form: {
        name: "",
        status: "",
        funQuan: [],
        dataLook: [], //数据看板数据
        jobLook: [], //工作台数据，后台返回
        dataQuan: "",
        serverId: "1",
      },
      dataArr: [], //数据看板菜单数组
      homeArr: [], //首页的功能模块菜单
      allArr: [],
      id: null,
      homeNameId: [],
      isDetail: null,
      menuType: [],
      fuwuduan: [],
    };
  },
  created() {
    this.getServer();

    if (this.$route.query.isDetail) {
      this.isDetail = 1;
    } else {
      this.isDetail = null;
    }
    this.getMenu();
    this.getMenuType();
    if (this.$route.query.id) {
      this.form.serverId = "1";

      this.id = this.$route.query.id;
      setTimeout(() => {
        this.getDetail();
      }, 200);
    }
  },
  methods: {
    changeServer() {
      if (this.$route.query.id) {
        this.getDetail(1);
        this.getMenu();
      }
    },
    getServer() {
      this.$api.home.serverHttp().then((res) => {
        if (res.code === 200) {
          let serverArr = res.data;

          // 等待 getFuwu 函数的结果，并更新 serverArr
          this.getFuwu(serverArr).then((updatedServerArr) => {
            this.fuwuduan = updatedServerArr;
          });
        }
      });
    },
    getFuwu(n) {
      // 返回一个 Promise
      return new Promise((resolve, reject) => {
        this.$api.dict
          .list({ dictName: "服务管理" })
          .then((res) => {
            if (res.code === 200) {
              let arr = n.map((itemA) => {
                // 在 B 数组中查找匹配的项
                let matchedItemB = res.data.find(
                  (itemB) => itemB.dictValue === itemA.id
                );

                // 如果找到匹配项，更新 itemA 的 name 字段
                if (matchedItemB) {
                  itemA.name = matchedItemB.dictName;
                }

                return itemA;
              });

              // 解析 Promise，返回更新后的数组
              resolve(arr);
            } else {
              // 如果请求失败，拒绝 Promise
              reject(new Error("Failed to fetch dictionary list."));
            }
          })
          .catch((error) => {
            // 捕获并处理任何网络错误或其他异常
            reject(error);
          });
      });
    },
    homeCheckAll(e, v) {
      if (e) {
        // 选中"全部"
        v.children.forEach((child) => {
          if (!this.form.jobLook.includes(child.id)) {
            this.form.jobLook.push(child.id);
            v.indeterminate = false;
          }
        });
      } else {
        // 取消选中"全部"
        const idsToRemove = v.children.map((child) => child.id);
        this.form.jobLook = this.form.jobLook.filter(
          (id) => !idsToRemove.includes(id)
        );
        v.indeterminate = true;
      }
    },
    dataCheckAll(e, v) {
      if (e) {
        // 选中"全部"
        v.children.forEach((child) => {
          if (!this.form.dataLook.includes(child.id)) {
            this.form.dataLook.push(child.id);
            v.indeterminate = false;
          }
        });
      } else {
        // 取消选中"全部"
        const idsToRemove = v.children.map((child) => child.id);
        this.form.dataLook = this.form.dataLook.filter(
          (id) => !idsToRemove.includes(id)
        );
        v.indeterminate = true;
      }
    },

    // ======字典表所属菜单
    getMenuType() {
      this.$api.dict.list({ dictName: "H5菜单权限所属模块" }).then((res) => {
        if (res.code === 200) {
          this.menuType = [];
          res.data.forEach((v) => {
            if (v.dictPid !== 0) {
              this.menuType.push(v);
            }
          });
        }
      });
    },
    funQuanChange(e) {
      if (!e.includes("首页")) {
        this.form.jobLook = [];
      } else if (!e.includes("数据")) {
        this.form.dataLook = [];
      }
    },
    saveData(d) {
      let that = this;
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认保存吗?", "info")
            .then(() => {
              if (!this.$route.query.id) {
                console.log(333);
                this.homeNameId = [];
                this.allArr.forEach((v) => {
                  v.children.forEach((v2) => {
                    if (
                      that.form.dataLook.includes(v2.id) &&
                      that.homeNameId.indexOf(v2.pid) == -1
                    ) {
                      that.homeNameId.push(v2.pid);
                    }
                  });
                });
                this.allArr.forEach((v) => {
                  v.children.forEach((v2) => {
                    if (
                      that.form.jobLook.includes(v2.id) &&
                      that.homeNameId.indexOf(v2.pid) == -1
                    ) {
                      that.homeNameId.push(v2.pid);
                    }
                  });
                });
                const newArrEdit = [];
                newArrEdit.push(
                  ...that.homeNameId,
                  ...that.form.dataLook,
                  ...that.form.jobLook
                );
                this.$api.staff
                  .staffRoleCao({
                    status: 1,
                    serverId: "1",
                    name: this.form.name,
                    menus: newArrEdit.join(","),
                    dataStatus: this.form.dataQuan,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("新增成功", "success");
                      this.$router.push("/staff/staffRole");
                    }
                  });
              } else {
                this.homeNameId = [];
                this.allArr.forEach((v) => {
                  v.children.forEach((v2) => {
                    if (
                      (that.form.dataLook.includes(v2.id) &&
                        that.homeNameId.indexOf(v2.pid) == -1) ||
                      (that.form.jobLook.includes(v2.id) &&
                        that.homeNameId.indexOf(v2.pid) == -1)
                    ) {
                      that.homeNameId.push(v2.pid);
                    }
                  });
                });
                console.log(that.homeNameId, "that.homeNameId");
                console.log(that.form.dataLook, "that.form.dataLook");
                console.log(that.form.jobLook, "that.form.jobLook");

                const newArr = [];
                newArr.push(
                  ...that.homeNameId,
                  ...that.form.dataLook,
                  ...that.form.jobLook
                );
                this.$api.staff
                  .staffRoleCao({
                    serverId: "1",

                    status: 1,
                    name: this.form.name,
                    menus: [...new Set(newArr)].join(","),
                    dataStatus: this.form.dataQuan,
                    id: that.id,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("编辑成功", "success");
                      // this.$router.push("/staff/staffRole");
                    }
                  });
              }
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    getMenu() {
      this.$api.system
        .userMenuListNew({
          serverId: Number(this.form.serverId)
            ? Number(this.form.serverId)
            : Number(this.$route.query.serverId)
            ? Number(this.$route.query.serverId)
            : "",
        })
        .then((res) => {
          if (res.code === 200) {
            var data = res.data.filter((e) => e.pid == 0);
            this.dataArr = [];
            this.homeArr = [];

            var temp = [];
            data.forEach((e) => {
              e.children = res.data.filter((c) => c.pid == e.id);
              temp.push(e);
            });
            this.allArr = temp;
            temp.forEach((v) => {
              if (v.name === "数据") {
                // v.checkboxAll = false;
                this.dataArr.push(v);
              } else {
                // v.checkboxAll = false;
                this.homeArr.push(v);
              }
            });
          }
        });
    },

    // homeChange(event, item) {
    //   // 根据所有子级复选框的状态控制父级复选框的选择状态
    //   const labelList = item.children.map((child) => child.id);
    //   if (this.isSubset(labelList, this.form.jobLook)) {
    //     item.checkboxAll = true;
    //   } else {
    //     item.checkboxAll = false;
    //   }
    // },
    // isSubset(arr1, arr2) {
    //   // 判断 arr1 是否为 arr2 的子集
    //   return arr1.every((val) => arr2.includes(val));
    // },

    // 改变首页数据
    homeChange(event, v) {
      // 更新form.jobLook数组
      this.form.jobLook = event;
      // 判断是否全部子项都被选中
      const allChildSelected = v.children.every(
        (child) => this.form.jobLook.indexOf(child.id) !== -1
      );

      // 更新全部按钮的勾选状态
      if (allChildSelected) {
        v.checkboxAll = true;
        this.$forceUpdate();
      } else {
        v.checkboxAll = false;
        this.$forceUpdate();
      }
    },
    removeElement(arr, element) {
      const index = arr.indexOf(element);
      if (index !== -1) {
        arr.splice(index, 1);
      }
    },
    dataChange(event, v) {
      // 更新form.jobLook数组
      this.form.dataLook = event;

      // 判断是否全部子项都被选中
      const allChildSelectedNew = v.children.every((child) =>
        this.form.dataLook.includes(child.id)
      );

      // 更新全部按钮的勾选状态
      if (allChildSelectedNew) {
        v.checkboxAll = true;
        this.$forceUpdate();
      } else {
        v.checkboxAll = false;
        this.$forceUpdate();

        this.indeterminate = false;
      }
    },

    // 详情
    getDetail() {
      this.$api.staff
        .staffRoleDetail({
          id: this.id,
          serverId: this.form.serverId
            ? this.form.serverId
            : this.$route.query.serverId,
        })
        .then((res) => {
          console.log(res, "详情-员工");
          if (res.code === 200) {
            this.form.name = res.data.name;
            this.form.status = res.data.status.toString();
            this.form.dataQuan = res.data.dataStatus.toString();
            res.data.futureCompanyMenuBeans.forEach((v, i) => {
              console.log(v, "数据类型");
              this.menuType.forEach((v2) => {
                if (v.type === v2.dictId) {
                  v.type = v2.dictName;
                } else {
                  v.type = v.type;
                }
              });

              if (v.type === "数据") {
                this.form.funQuan.push("数据");
              } else if (v.type === "首页") {
                this.form.funQuan.push("首页");
              }
              v.childrens.forEach((v2) => {
                if (v.type === "数据") {
                  this.form.dataLook.push(Number(v2.id));
                } else {
                  this.form.jobLook.push(Number(v2.id));
                }
              });
              // if (v.name === "数据") {
              //   // 判断是否全部子项都被选中
              //   const allChildSelected2 = v.childrens.every((child) =>
              //     this.form.dataLook.includes(child.id)
              //   );

              //   // 更新全部按钮的勾选状态
              //   if (allChildSelected2) {
              //     this.dataArr[i].checkboxAll = true;
              //   } else {
              //     this.dataArr[i].checkboxAll = false;
              //     // this.indeterminate = false;
              //   }
              // } else {
              //   // 判断是否全部子项都被选中
              //   const allChildSelected3 = v.childrens.every((child) =>
              //     this.form.jobLook.includes(child.id)
              //   );
              //   // 更新全部按钮的勾选状态
              //   if (allChildSelected3) {
              //     this.homeArr[i].checkboxAll = true;
              //   } else {
              //     this.homeArr[i].checkboxAll = false;
              //     // this.indeterminate = false;
              //   }
              // }
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input {
  width: 25%;
}
.el-select {
  width: 25% !important;
}

.quan {
  width: 35%;
}
.dataBox {
  border: 1px solid var(--input-border);
  padding: 10px;
  margin-top: 15px;
}
</style>
